export function fleetStartupReady(loading: boolean, machineCount: number) {
  return !loading || machineCount > 0
}
